import(/* webpackMode: "eager" */ "/vercel/path0/cohera-frontend/app/global-error.tsx");
